import {
  LocationCodes,
  CalculateRequest,
} from '@/dto/calculate/CalculateRequest'

export default function CalculateRequestFactory({
  source,
  destination,
  weight,
  dimensions,
  price,
  currency,
}: {
  source: LocationCodes
  destination: LocationCodes
  weight: number
  price: number
  dimensions: number[]
  currency: string
}): CalculateRequest {
  return {
    source: source,
    destination: destination,
    products: [{ weight, price, dimensions }],
    currency: currency,
  }
}
